<template>
  <p class="concept-credo">
    <span v-for="(line, lineIndex) in lines" :key="lineIndex" class="credo-line" data-home-enter="creed">
      <template v-for="(token, index) in line" :key="index"><span class="credo-word"><span>{{ token.word }}</span></span>{{ token.punctuation }}{{ index < line.length - 1 ? ' ' : '' }}</template>
    </span>
  </p>
</template>

<script>
const lines = ['I explore.', 'I try to understand.', 'I build from there.'].map(line =>
  line.split(' ').map(token => ({ word: token.replace(/\.$/, ''), punctuation: token.endsWith('.') ? '.' : '' }))
);

export default {
  name: 'HomeCreed',
  data: () => ({ lines }),
};
</script>

<style scoped>
.credo-line { display: block; white-space: nowrap; }
/* Each sentence owns its line, so a bold word cannot reflow another sentence. */
.credo-word { display: inline; pointer-events: auto; }
.credo-word > span { font-weight: inherit; transition: font-weight 180ms ease; }
@media (hover: hover) and (pointer: fine) {
  .credo-word:hover > span { font-weight: 700; }
}
@media (hover: none), (pointer: coarse) {
  .credo-word:active > span { font-weight: 700; }
}
@media (prefers-reduced-motion: reduce) {
  .credo-word > span { transition: none; }
}
</style>
